
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 87.72 87.95"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M55.53 16.65a2.71 2.71 0 00-1.4 5.23l19.63 5.26-67.9 39.2A2.71 2.71 0 008.57 71l67.58-39L71 51.28a2.71 2.71 0 105.23 1.4l6.7-25.12a2.5 2.5 0 00.29-1.39 2.71 2.71 0 00-2-2.64zm26.24 10h.07z","fill":"#fff","data-name":"Livello 2"}})])
          )
        }
      }
    